<template>
  <div class="content">
    <div class="page">
      <div class="weui-flex exam_top">
        <div class="weui-cell_primary count"><i class="iconfont icon-clock" style="font-size: 17px;margin-right: 10px;"></i>
          倒计时
          <van-count-down  ref="countDown" :auto-start="false" :time="time" @finish="finish" @change="timechange" style="display:inline-block" />
        </div>
        <div class=""><a href="javascript:;" class="weui-btn weui-btn_default goback" @click="onClickLeft">返回</a>
        </div>
      </div>
      <div class="content_body">
        <div class="exam_question">
          <van-tag type="primary" class="exam_type">{{ question.type == 1 ? '单选题' : '判断题' }}</van-tag>
          <p>{{ question_index + 1 }}、{{ question.title }}</p>
        </div>

        <van-radio-group v-model="mock_anser.index" class="q_choice">
          <van-radio v-for="(item, index) in ansewerList" @click="chooseExamAnser(index)" :key="index" :name="index"
            icon-size="20px" class="m30" style="font-size:16px">{{ item }}</van-radio>
        </van-radio-group>

        <div class="m40 btn_nav">
          <van-button type="info" size="normal" @click="exam_pre">上一题</van-button>
          <van-button type="info" size="normal" @click="exam_next">下一题</van-button>
        </div>
        <div class="exam_over">
          <span @click="exam_set_tag">
            <van-icon name="checked" :color="mock_anser.iftag?'#1989fa':'#c8c9cc'" />
            <i :style="{'font-size':'14px','color': mock_anser.iftag?'#1989fa':'#c8c9cc'}">标记</i>  
          </span>
          <span class="jj" @click="check_exam">交卷</span>
          <span @click="exam_mask = true">
            <i class="iconfont icon-gengduo" style="font-weight: normal;margin-right: 15px"></i>
            {{ question_index + 1 }}<font style="color: #cccccc">/100</font>
          </span>

        </div>
        <div class="mock_exam_ist" v-if="exam_mask" @click="exam_mask = !exam_mask">
          <li v-for="(item, index) in mock_anser_list" :key="index"
            :class="{ hover: item.choose != 99, tag: item.iftag }" @click="goExamQuetion(index)">{{ index + 1 }}</li>
        </div>
      </div>

      <div class="exam_mask" v-if="exam_mask" @click="exam_mask = !exam_mask"></div>
    </div>

  </div>


</template>

<script>
import { getExamQue, saveExam } from '../../api/onlineexam';
export default {
  data() {
    return {
      examid:'',
      time: 60 * 60 * 1000,//剩余时间
      quetionList: [],
      question: {
        answer: "",
        choice: '',
        id: '',
        question: '',
        questionType: '',
        questionValue: '',
        status: '',
        workId: '',
      },/*问题内容对象*/
      question_index: null,/*当前第几题*/

      exam_mask: false,
      mock_anser_list: [],
      chars: ["A", "B", "C", "D", "E", "F", "G"],
      ansewerList: [],
      /*客户模拟考题目选择*/
      mock_anser: {
        id: null,
        choose: 99,
        index: null,
        iftag: false,
        result: null
      },

    }

  },
  created() {
    this.examid = this.common.getQueryString("examid")
    let that=this
    if (localStorage.getItem(this.examid + "-que") != null) {
      this.quetionList = JSON.parse(localStorage.getItem(this.examid + "-que"))
      this.time = localStorage.getItem(this.examid + "-count")
      this.mock_anser_list = JSON.parse(localStorage.getItem(this.examid + "-answerList"))
      this.question_index = localStorage.getItem(this.examid + "-queNow")
      this.$nextTick(()=>{
        that.$refs.countDown.start();
      })
      
    } else {
      getExamQue( this.examid).then(res => {
        console.log(res)
        if (!res.success) {
          that.$dialog.alert({
            message: res.message
          }).then(() => {
            that.$router.back()
          })
          return
        }else{
          this.quetionList = this.quetionList.concat(res.data.chooselist).concat(res.data.judgeList)
        //缓存题目
        localStorage.setItem(this.examid + '-que', JSON.stringify(this.quetionList))
        this.question_index = 0;
        for (var j = 0; j < this.quetionList.length; j++) {
          let mock_anser = {}
          mock_anser.id = this.quetionList[j].id;
          mock_anser.result = '';
          mock_anser.iftag = false;
          mock_anser.choose = 99
          this.mock_anser_list[j] = mock_anser;
          if (j == this.quetionList.length - 1) {
            //缓存初始结果
            localStorage.setItem(this.examid + '-answerList', JSON.stringify(that.mock_anser_list))
          }
        }
        }
        that.$refs.countDown.start();
      
        
      })
    }
  },
  watch: {
    question_index() {
      this.question = this.quetionList[this.question_index];
      console.log(this.question)
      this.mock_anser = this.mock_anser_list[this.question_index];
      //缓存当前做第几题
      localStorage.setItem(this.examid+'-queNow',this.question_index) 
      if (this.question.type == 1) {
        this.ansewerList = this.question.choice.split("|");
      } else {
        this.ansewerList = ["错误","正确"];
      }

    },
  },
  methods: {
    onClickLeft() {
      this.$router.back()
    },
    //计时结束 强制交卷
    finish() {
      this.up_exam()
      this.$dialog.alert({
        message: '考试时间到，系统已自动交卷'
      }).then(() => {
        this.$router.push('/login')
      })
    },
    //时间变化
    timechange(val) {
      //缓存考试时间
      localStorage.setItem(this.examid + '-count', (val.minutes * 60 + val.seconds) * 1000)
    },
    /*模拟考试选择答案*/
    chooseExamAnser(index) {
      let vm = this
      let mock_anser = this.mock_anser_list[vm.question_index];
      if (this.question.type == 1) {
        mock_anser.choose = index;
        mock_anser.result = this.chars[index]
      } else {
        mock_anser.choose = index;
        mock_anser.result = index+""
      }
      //缓存当前答题进度
      localStorage.setItem(this.examid + '-answerList', JSON.stringify(this.mock_anser_list))
      // console.log(this.mock_anser_list[this.question_index])

    },
    /*模拟考试下一题*/
    exam_next() {
      if (this.question_index == this.quetionList.length - 1) {
        return
      }
      this.question_index++;
    },
    /*模拟考试上一题*/
    exam_pre() {
      if (this.question_index == 0) {
        return
      }
      this.question_index--;
    },
    /*模拟考试错误遮罩下一题*/
    exam_mask_next() {
      this.question_index++;
      this.exam_mask = false;
      this.result_detail = false;
      this.result = false;
      //$("#form1")[0].reset();
    },
    /*模拟考试标志*/
    exam_set_tag() {
      this.mock_anser.iftag = !this.mock_anser.iftag;
      this.mock_anser_list[this.question_index] = this.mock_anser;
    },

    /*交卷前检查*/
    check_exam() {
      console.log("开始交卷")
      let vm = this
      console.log(vm.mock_anser_list)
      vm.null_num = 0;
      vm.true_num = 0;
      vm.mock_error_list = [];
      for (var i = 0; i < vm.mock_anser_list.length; i++) {
        if (vm.mock_anser_list[i].choose == 99) {
          vm.null_num++;
        }
        if (vm.mock_anser_list[i].result > 0) {
          vm.true_num++;
        }
        if (vm.mock_anser_list[i].choose != 99 && vm.mock_anser_list[i].result == 0) {
          vm.mock_error_list.push(vm.mock_anser_list[i].id)
        }
      }
      if (vm.null_num > 0) {
        this.$dialog({
          title: "温馨提示",
          showCancelButton: 'true',
          message: "您还有" + vm.null_num + "道题未答题，确认交卷吗?",
          cancelButtonText: "继续答题",
          cancelButtonColor: '#000000',
          confirmButtonText: '确认交卷'
        }).then(() => {
          vm.up_exam();
        }).catch(() => {
          console.log('点击了取消')
        })
      } else {
        this.$dialog({
          title: "温馨提示",
          showCancelButton: 'true',
          message: "交卷后不能重复考试，是否确认交卷吗?",
          cancelButtonText: "继续答题",
          cancelButtonColor: '#000000',
          confirmButtonText: '确认交卷'
        }).then(() => {
          vm.up_exam();
        }).catch(() => {
          console.log('点击了取消')
        })
      }
    },

    /*模拟考试交卷*/
    up_exam() {
      var vm = this;
      let param={
        id:vm.examid,
        examVos:vm.mock_anser_list
      }
      saveExam(param).then(res => {
        if (res.success) {
          localStorage.removeItem(this.examid + "-que")
          localStorage.removeItem(this.examid + "-count")
          localStorage.removeItem(this.examid + "-answerList")
          localStorage.removeItem(this.examid + "-queNow")
          this.$dialog.alert({
            message: '交卷成功，返回查看结果'
          }).then(() => {
            this.$router.push('/examlist')
          })
        }
      })

    },
    /*模拟考试跳转*/
    goExamQuetion(index) {
      this.question_index = index;
    },
    /*统计详情*/
    getcount() {
      this.alert_if = true;
      this.alert_title = "统计详情";
      if (this.userInfo.answerNum) {
        this.alert_content = "共回答：" + this.userInfo.answerNum + ",答错" + this.userInfo.wrongNum + "继续努力!"
      } else {
        this.alert_content = "暂无统计记录"
      }


    },
  }


};
</script>

<style>
.btn_nav {
  display: flex;
  justify-content: space-around;
  position: fixed;
  width: 100%;
  bottom: 62px
}

.q_choice {
  width: 100%;
  padding: 0 15px;
}

.exam_mask {
  position: absolute;
  width: 100%;
  height: 100%;
  display: block;
  top: 0px;
  left: 0px;
  background: rgba(3, 3, 3, .5);
  z-index: 99;
}

.weui-flex {
  display: flex;
}

* {
  box-sizing: border-box;
}

.txtRight {
  text-align: right;
  padding-right: 15px;
}

.colMain {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.box {
  padding: 15px;
  font-size: 14px;
}

.mt10 {
  margin-top: 10px;
}

em,
i {
  font-style: normal;
}

.content,
.page {
  position: absolute;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  background: #fff;
}

.page {
  overflow: auto;
  transition: all .5s;
  position: absolute;
  top: 0px;
  right: 0;
  bottom: 0
}

.btn1 {
  display: inline-block;
  width: 100%;
  height: 45px;
}

.btn_list {
  flex-wrap: wrap;
  padding: 0px 15px;
  background: #ffffff;
  margin-top: 13px;
  position: relative
}

.btn_list a {
  position: relative;
  width: 25%;
  text-align: center;
  padding: 10px;
  box-sizing: border-box;
  color: #333333;
  font-size: 14px;
}

.check_switch_box input:after {
  width: 24px;
  height: 24px;
  border-radius: 12px;
}

.check_switch_box input:before {
  width: 24px;
  height: 24px;
  border-radius: 12px;
}

.weui-switch:checked:after,
.weui-switch-cp__input:checked~.weui-switch-cp__box:after {
  -webkit-transform: translateX(26px);
  transform: translateX(26px);
}

.weui-cells {
  margin-top: 1.17647059em;
  background-color: #FFFFFF;
  line-height: 1.47058824;
  font-size: 17px;
  overflow: hidden;
  position: relative;
}

.weui-cell {
  padding: 10px 15px;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.weui-cell__bd {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.weui-cells_checkbox .weui-cell__hd {
  padding-right: 0.35em;
}

.user_info img {
  width: 72px;
  height: 72px;
}

.page p {
  font-size: 16px;
  margin: 0
}

.page .green {
  color: #1aad19
}

.user_info .wechat {
  font-size: 15px;
  color: #999999;
}

.page .title {
  line-height: 40px;
  padding-left: 15px;
}

.page select {
  color: #666666;
  font-size: 16px;
  direction: rtl;
}

.page label {
  color: #333333;
  font-size: 16px;
  box-sizing: border-box;
}

.footer {
  width: 100%;
  font-size: 14px;
  margin-top: 10px;
}

.footer p {
  font-size: 14px;
}

.footer p a {
  color: #808080;
}

.exam_top {
  width: 100%;
  justify-content: space-between;
  padding: 5px 15px;
  box-sizing: border-box;
  background-color: #fff;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 99;
  display: flex;
}

.page a.goback {
  padding: 0px 10px;
  font-size: 14px;
  line-height: 1.8;
  color: #666666;
}

.exam_top .title_name {
  color: #666666;
  font-size: 14px;
}

.exam_top .count {
  font-size: 16px;
  font-weight: bold;
  color: #3366CC;
  flex: 1;
  text-align: center
}

.exam_question {
  padding: 15px;
  justify-content: flex-start;
  background-color: #f8f8f8;
}

.exam_question .exam_type {
  float: left;
  /* background-color: #1aad19; */
  /* color: #fff; */
  padding: 2px 10px;
  /* font-size: 13px; */
  margin-right: 5px;
}

.exam_check label {
  border: none
}

.exam_check.weui-cells:after,
.exam_check.weui-cells:before {
  border: none
}

.exam_check label:before {
  border: none
}

.exam_go {
  justify-content: space-between;
  padding: 46px 15px;
  position: fixed;
  display: flex;
  width: 100%;
  box-sizing: border-box;
  bottom: 0px;
  left: 0px;
  z-index: 99;
  background: #ffffff
}

.exam_go a {
  font-size: 18px;
  width: 96px;
  text-align: center;
  box-sizing: border-box;
  line-height: 38px;
  margin: 0px;
}

.exam_go .weui-btn+.weui-btn {
  margin-top: 0px
}

.exam_tip {
  flex-wrap: wrap;
  padding: 0px 15px;
  margin-top: 20px;
}

.exam_tip .exam_result {
  color: red;
  font-weight: bold
}

.exam_tip .exam_answer {
  text-align: center;
  position: relative;
  margin-top: 20px;
}

.exam_tip .exam_answer span:before {
  height: 1px;
  width: 33%;
  border-top: 1px solid #808080;
  content: "";
  position: absolute;
  top: 12px;
  left: 0px
}

.exam_tip .exam_answer span:after {
  height: 1px;
  width: 33%;
  border-top: 1px solid #808080;
  content: "";
  position: absolute;
  top: 12px;
  right: 0px
}

.exam_tip .exam_choose {
  font-size: 16px;
  justify-content: space-between;
  margin-top: 20px;
}

.exam_tip .exam_choose a {
  line-height: 20px;
  padding: 2px 15px;
  margin: 0px;
}

.exam_tip .exam_answer_content {}

.exam_tip>div {
  width: 100%;
}

.que_list p {
  text-align: justify;
}

.que_list .exam_tip {
  margin-top: 0px;
}

.que_list {
  margin-top: 10px
}

.que_list:nth-child(1) {
  margin-top: 0px
}

.content_body {
  margin-top: 35px;
  /* overflow: scroll;
  height: 100%; */
  padding-bottom: 130px;
}


.exam_over {
  padding: 8px 15px;
  position: fixed;
  left: 0px;
  bottom: 0px;
  width: 100%;
  box-sizing: border-box;
  justify-content: space-between;
  /*overflow: hidden;*/
  height: 50px;
  box-sizing: border-box;
  z-index: 5;
  display: flex;
  align-items: center;
}

.exam_over:before {
  content: " ";
  position: absolute;
  left: 15px;
  bottom: 49px;
  right: 15px;
  height: 1px;
  border-bottom: 1px solid #000000;
  color: #D9D9D9;
  -webkit-transform-origin: 0 100%;
  transform-origin: 0 100%;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}

.exam_over span {
  width: 30%;
  font-size: 16px;
  float: left;
  color: #333333;
  text-align: center
}

.exam_over span:first-child {
  width: 30%;
  display: inline-flex;
  align-items: center;
}

.exam_over span:last-child {
  width: 30%;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
}

.exam_over span i {
  font-size: 20px;
  color: #323232;
}

.exam_over span i.iconfont {
  margin-right: 20px
}

.exam_over span.jj {
  width: 28%;
  font-size: 14px;
  text-align: center;
  box-sizing: border-box;
  background: #3366CC;
  color: #ffffff;
  border-radius: 4px;
  line-height: 33px;
}

.exam_over span.jj .circle_top {
  border-top: 2px solid #000000;
  width: 80px;
  height: 80px;
  text-align: center;
  display: inline-block;
  box-sizing: border-box;
  border-radius: 50%;
  position: relative;
  z-index: 8088888;
  background: #fff;
}

.exam_over span em {
  font-size: 18px;
  color: #fff;
  background: #3366CC;
  border-radius: 50%;
  display: inline-block;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-style: normal;
  margin-top: 10px;
  z-index: 10
}

.center {
  margin: 0 auto
}

.flexable {
  display: flex;
  justify-content: space-between;
  align-items: center
}

select {
  text-decoration: none;
  border: none;
  background: url("../../asset/images2/right.png") right center no-repeat;
  padding-right: 15px;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  font-size: 14px;
  color: #666666;
  background-size: 6px 9px;
  text-align: right;
}

.blank2 {
  background: #f2f2f2;
  width: 100%;
  height: 10px;
}

.head {
  background: url("../../asset/images2/top_bg.jpg") no-repeat;
  background-size: 100% 245px;
  width: 100%;
  height: 208px;
}

.top {
  width: 100%;
  height: 37px;
  padding: 0 15px
}

.top span {
  color: #ffffff;
  background: url("../../asset/images2/close.png") left center no-repeat;
  background-size: 12px 12px;
  font-size: 15px;
  padding-left: 16px;
}

.top img {
  width: 16px;
}

.info {
  width: 100%;
  justify-content: flex-start;
  padding: 20px 15px 0;
}

.info .avata {
  padding: 5px;
  background: #9bddea;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
}

.avata img {
  width: 68px;
  height: 68px;
  border-radius: 50%;
}

.page p.name {
  margin-left: 15px;
}

.name span {
  display: block;
  font-size: 15px;
  color: #ffffff;
  background: url("../../asset/images2/head_icon.png") left center no-repeat;
  background-size: 15px 16px;
  padding-left: 22px;
  line-height: 32px;
}

.name em {
  text-align: center;
  color: #ffffff;
  font-size: 12px;
  width: 68px;
  line-height: 23px;
  background: rgba(0, 0, 0, .2);
  display: inline-block;
  border-radius: 9px;
}

.time_end {
  position: absolute;
  font-size: 14px;
  color: #ffffff;
  right: 15px;
  margin-top: 35px;
}

.vip {
  width: 347px;
  height: 76px;
  background: #ffffff;
  border-radius: 10px;
  margin-top: 18px;
  align-items: center;
}

.vip a {
  width: 50%;
  text-align: center;
  font-size: 15px;
  color: #333333;
  padding-top: 30px;
  height: 50px;
}

.vip a:first-child {
  background: url("../../asset/images2/vip.png") center top no-repeat;
  background-size: 26px 22px;
}

.vip a:last-child {
  background: url("../../asset/images2/rang.png") center top no-repeat;
  background-size: 23px;
}

.select_box {
  width: 100%;
  padding: 0 15px 10px;
}

.select_content {
  justify-content: space-between;
  width: 100%;
  height: 31px;
  padding-left: 10px;
  padding-bottom: 10px;
  margin-top: 10px;
}

.select_content:last-child {
  border: none
}

.select_content label {
  background: url("../../asset/images2/type.png") left center no-repeat;
  background-size: 19px 20px;
  padding-left: 28px;
  font-size: 15px;
}

.select_content label.l2 {
  background: url("../../asset/images2/type2.png") left center no-repeat;
  background-size: 19px 20px;
}

.select_c {
  width: 3px;
}

.select_c select {
  float: right;
  font-size: 14px;
}

.page .title {
  font-size: 16px;
  color: #666666;
  margin-left: 10px;
  line-height: 45px;
  padding-left: 0
}

.opt1 {
  width: 100%;
  padding: 0 15px
}

.btn_list1 {
  width: 100%;
  justify-content: space-between;
  padding: 20px 0 15px 0;
  border-bottom: 1px solid #eeeeee;
}

.opt1 a {
  font-size: 14px;
  color: #333333;
  padding-top: 32px;
  width: 25%;
  text-align: center;
}

.opt1 a:first-child {
  background: url("../../asset/images2/icon1.png") center top no-repeat;
  background-size: 26px 24px;
}

.opt1 a:nth-child(2) {
  background: url("../../asset/images2/icon2.png") center top no-repeat;
  background-size: 26px 24px;
}

.opt1 a:nth-child(3) {
  background: url("../../asset/images2/icon3.png") center top no-repeat;
  background-size: 25px 24px;
}

.opt1 a:nth-child(4) {
  background: url("../../asset/images2/icon4.png") center top no-repeat;
  background-size: 26px 24px;
}

.opt2 {
  width: 100%;
  justify-content: center;
  padding: 0 15px;
}

.opt2 .moni {
  width: 57%;
  background: url("../../asset/images2/icon7.png") center 10px no-repeat;
  background-size: 130px 130px;
  text-align: center;
  color: #333333;
  font-size: 15px;
  padding-top: 150px;
  height: 194px;
}

.opt2 .opt_more {
  width: 43%;
  height: 194px;
  flex-wrap: wrap;
  justify-content: flex-start;
  flex-direction: column;
  border-right: 1px solid #ebebeb
}

.opt2 .opt_more a {
  width: 100%;
  padding-top: 40px;
  line-height: 30px;
  font-size: 14px;
  color: #333333;
  text-align: center;
}

.opt2 .opt_more a:first-child {
  background: url("../../asset/images2/icon5.png") top center no-repeat;
  background-size: 40px 40px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebebeb;
  margin-top: 18px;
}

.opt2 .opt_more a:last-child {
  background: url("../../asset/images2/icon6.png") top center no-repeat;
  background-size: 40px 40px;
  margin-top: 10px
}

.footer {
  background: #149d6f;
  height: 62px;
  padding: 10px 0;
  position: fixed;
  width: 100%;
  bottom: 0;
}

.footer p {
  text-align: center;
  font-size: 14px;
  color: #ffffff;
  line-height: 21px;
  margin: 0;
}

.footer p a {
  display: inline-block;
  background: #34d66f;
  text-align: center;
  width: 60px;
  height: 21px;
  border-radius: 5px;
  color: #ffffff;
}

.vip_head {
  padding: 25px 15px 0;
}

.vip_head img {
  width: 100%;
}

.vipList {
  padding: 0 15px;
  margin-top: 10px;
}

.vipList .vip_tit {
  font-size: 14px;
  color: #666666;
  height: 40px;
  line-height: 40px;
}

.vipli {
  border-bottom: 1px solid #e5e5e5;
  padding: 0 10px 12px;
  justify-content: space-between;
  margin-top: 17px;
}

.vip_left {
  display: inline-flex;
  align-items: center;
}

.vip_left img {
  width: 33px;
  height: 32px;
}

.vip_left p {
  font-size: 12px;
  color: #666666;
  margin-left: 6px
}

.vip_left p span:first-child {
  display: block;
  font-size: 14px;
  color: #333333
}

.vip_right {
  color: #808080;
  font-size: 10px;
  margin-right: 10px;
}

.vip_right em {
  color: #333333;
  font-size: 16px;
  margin: 0 4px
}

.buy_btn {
  width: 100%;
  padding: 25px 25px;
}

.buy_btn a {
  display: block;
  text-align: center;
  line-height: 37px;
  height: 37px;
  background: #04b8ae;
  color: #ffffff;
  border-radius: 5px;
  font-size: 14px;
}


.mock_exam {
  justify-content: space-between;
  align-items: center;
  padding: 0px 15px;
  position: fixed;
  width: 100%;
  box-sizing: border-box;
  bottom: 62px;
  display: flex;
}

.mock_exam a {
  font-size: 16px;
  width: 65px;
  text-align: center;
  box-sizing: border-box;
  margin: 0px;
  padding: 0px;
}

.mock_exam span {
  font-size: 18px;
  text-align: center;
  box-sizing: border-box;
  margin: 0px;
  padding: 10px;
  background: #f8f8f8;
  color: #333333;
  border-radius: 5px;
}

.mock_exam span i {
  font-weight: bold
}

.mock_exam span.choosed {
  background: #3366CC;
  color: #ffffff
}

.mock_exam_ist {
  position: fixed;
  width: 300px;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  top: 50%;
  left: 50%;
  margin-top: -200px;
  margin-left: -150px;
  padding: 10px;
  box-sizing: border-box;
  flex-wrap: wrap;
  border: 1px solid #f8f8f8;
  overflow: scroll;
  z-index: 100;
  background: #ffffff;
  border-radius: 10px;
}

.mock_exam_ist li {
  background: #f8f8f8;
  box-sizing: border-box;
  border-radius: 5px;
  color: #333333;
  list-style: none;
  display: inline-block;
  text-align: center;
  width: 50px;
  text-align: center;
  margin-top: 10px;
  line-height: 28px;
}

.mock_exam_ist li.hover {
  background: #2D93CA;
  color: #ffffff;
}

.mock_exam_ist li.tag {
  background: #2D93CA;
  color: red;
}

.mock_error {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
}

.exam_mask {
  position: absolute;
  width: 100%;
  height: 100%;
  display: block;
  top: 0px;
  left: 0px;
  background: rgba(3, 3, 3, .5);
  z-index: 99;
}
</style>


